// extracted by mini-css-extract-plugin
module.exports = {"image_className":"responsiveBanner_image_className__2aebd","mobile_view":"responsiveBanner_mobile_view__mLq0e","desktop_view":"responsiveBanner_desktop_view___kNKE"};